(function($) {

	$.fn.msxiplaceholder = function(options) {
		// build main options before element iteration
		var opts = $.extend(true, {}, $.fn.msxiplaceholder.defaults, options);

        $('form').submit(function(){
            $(this).find('input.placeholder').val('');
        });

		return this.each(function() {
			var $this = $(this);
			// build element specific options
            var eOpts = $.metadata ? $.extend(true, {}, opts, $this.metadata()) : opts;
            eOpts = $.fn.dataset ? $.extend(true, eOpts, $this.dataset()) : eOpts;

            var placeholder = $this.attr('placeholder');
            if (placeholder !== undefined) {
                var currvalue = $this.attr("value");
                if (placeholder == currvalue) {
                    $this.addClass(eOpts.css_class);
                }
                if (currvalue == "") {
                    $this.addClass(eOpts.css_class);
                    $this.val(placeholder);
                }
                $this.focusin(function(){
                    if (placeholder == $this.val()) {
                        $this.val("").removeClass(eOpts.css_class);
                    }
                });

                $this.focusout(function(){
                    if ($this.val() == "") {
                        $this.val(placeholder).addClass(eOpts.css_class);
                    }
                });
            }
        });

	};
	//
	// plugin defaults
	//
	$.fn.msxiplaceholder.defaults = {
        css_class: 'placeholder'
	};

})(jQuery);